import React, { useState, useEffect, useRef } from 'react';
import { Swiper, SwiperSlide } from "swiper/react";
import { EffectFade, Autoplay } from 'swiper/modules';
import 'swiper/swiper-bundle.css';
import { motion } from "framer-motion"
import { useLenis } from '@studio-freight/react-lenis';
import { Link } from 'react-router-dom';

const SliderComponent = () => {
  const lenis = useLenis();
  const [activeIndex, setActiveIndex] = useState(0);
  const [totalSlides, setTotalSlides] = useState(0);
  const [swiperInstance, setSwiperInstance] = useState(null);

  const handleSlideChange = (swiper) => {
    setActiveIndex(swiper.activeIndex);
  };

  const handleIndicatorClick = (index) => {
    if (swiperInstance) {
      swiperInstance.slideTo(index);
    }
  };

  const handlePrevClick = () => {
    if (swiperInstance) {
      swiperInstance.slidePrev();
    }
  };

  const handleNextClick = () => {
    if (swiperInstance) {
      swiperInstance.slideNext();
    }
  };

  useEffect(() => {
    const swiper = document.querySelector('.swiper').swiper;
    setSwiperInstance(swiper);
    setTotalSlides(swiper.slides.length);
  }, []);

  const calculateProgressWidth = () => {
    if (totalSlides === 0) return '0%';
    const percentage = ((activeIndex + 1) / totalSlides) * 100;
    return `${percentage}%`;
  };


  const handleDownArrowClick = () => {
    if (lenis) {
      const viewportHeight = window.innerHeight;
      lenis.scrollTo(viewportHeight + 30);
    }
  };
  

  return (
    <div className='pb-20 md:pb-0 bg-black'>
      <div className="h-[60vh] md:h-[calc(100vh-9.5rem)] w-full bg-black">
        <Swiper
          className="h-full w-full"
          modules={[EffectFade, Autoplay]}
          effect="fade"
          fadeEffect={{ crossFade: true }}
          onSlideChange={handleSlideChange}
          speed={2000}
          autoplay={{ delay: 3000 }}
        >
          <SwiperSlide className="overflow-hidden">
            <motion.img animate={{ scale: activeIndex === 0 ? [1.1, 1, 1.1] : 1, transition: { duration: activeIndex === 0 ? 15 : 1, ease: 'easeIn', repeat: Infinity, repeatType: 'loop' } }} className="block h-full w-full object-cover align-bottom md:hidden" src="/images/slider/ulus-banner-mobil-new.jpg" />
            <motion.img animate={{ scale: activeIndex === 0 ? [1.1, 1, 1.1] : 1, transition: { duration: activeIndex === 0 ? 15 : 1, ease: 'easeIn', repeat: Infinity, repeatType: 'loop' } }} className="hidden md:block h-full w-full object-cover align-bottom" style={{ objectPosition: 'left 80%' }} src="/images/slider/ulus-banner-new.jpg" />
          </SwiperSlide>
          <SwiperSlide className="overflow-hidden">
            <Link to="/u-mega" className="block h-full w-full">
              <motion.img animate={{ scale: activeIndex === 1 ? [1.1, 1, 1.1] : 1, transition: { duration: activeIndex === 1 ? 15 : 1, ease: 'easeIn', repeat: Infinity, repeatType: 'loop' } }} className="block h-full w-full object-cover md:hidden" src="/images/slider/slider5-mobile.jpg" />
              <motion.img animate={{ scale: activeIndex === 1 ? [1.1, 1, 1.1] : 1, transition: { duration: activeIndex === 1 ? 15 : 1, ease: 'easeIn', repeat: Infinity, repeatType: 'loop' } }} className="hidden md:block h-full w-full object-cover align-bottom" style={{ objectPosition: 'left 80%' }} src="/images/slider/slider5.jpg" />
            </Link>
          </SwiperSlide>
          <SwiperSlide className="relative">
            <Link to="/house" className="block h-full w-full absolute inset-0 z-10">
              <span className="sr-only">House sayfasına git</span>
            </Link>
            <motion.img animate={{ scale: activeIndex === 2 ? [1.1, 1, 1.1] : 1, transition: { duration: activeIndex === 2 ? 15 : 1, ease: 'easeIn', repeat: Infinity, repeatType: 'loop' } }} className="h-full w-full object-cover object-center" src="/images/projects/house/1.jpg" />
            <div className="absolute top-0 left-0 h-full w-full flex flex-col justify-between z-20 px-[16.6%] md:px-0 pointer-events-none">
              <div className="flex md:justify-center md:items-center pt-20">
                <div className="relative w-full md:w-64 ">
                  <img src="/images/projects/house/logo-house-white-u.svg" className="w-full" alt="" />
                  <img src="/images/projects/house/logo-house-white-text.svg" className="w-full absolute top-0" alt="" />
                </div>
              </div>
            </div>
          </SwiperSlide>

        </Swiper>
      </div>

      <div className="h-14 w-full flex flex-col bg-black  border-b-[1px]  border-b-[#151515]">
        <div className="h-1 w-full bg-ulusOrange transition-all duration-1000 ease-in-out" style={{ width: calculateProgressWidth() }}></div>
        <div className="grid grid-cols-8 h-full">
          <div className="col-start-2 col-end-8 h-full w-full grid grid-cols-3">
            <div className="h-full flex items-center space-x-3">
              <a href='https://www.facebook.com/ulusinsaat' target='_blank'><img src="/images/social/1.svg" className="h-6" /></a>
              <a href='https://www.instagram.com/ulus.tr/' target='_blank'><img src="/images/social/2.svg" className="h-6" /></a>
              {/* <img src="/images/social/3.svg" className="h-6"/>
              <img src="/images/social/4.svg" className="h-6"/>
              <img src="/images/social/5.svg" className="h-6"/> */}
            </div>
            <div className="h-full w-full flex justify-center items-center">
      <img
        src="/images/icons/down-arrow.svg"
        className="h-2 cursor-pointer"
        onClick={handleDownArrowClick}
      />
    </div>
            <div className="h-full w-full flex items-center justify-end space-x-2">
              <img
                src="/images/icons/left-slider.svg"
                className="h-6 cursor-pointer"
                onClick={handlePrevClick}
              />
              <div className="h-full flex items-center justify-center space-x-1">
                {Array.from({ length: totalSlides }).map((_, index) => (
                  <div
                    key={index}
                    className={`h-1.5 w-1.5 ${
                      index === activeIndex ? 'bg-white' : 'border border-white'
                    } rounded-full cursor-pointer`}
                    onClick={() => handleIndicatorClick(index)}
                  ></div>
                ))}
              </div>
              <img
                src="/images/icons/right-slider.svg"
                className="h-6 cursor-pointer"
                onClick={handleNextClick}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SliderComponent;
